import { queryOptions } from '@tanstack/react-query';

import {
  createGuestBagRequestBody,
  mapGuestBagToOrderSummary,
} from './helpers';
import { type CheckoutProduct } from './types';

import { RQ_CHECKOUT_SUMMARY_GUEST } from '@/modules/ReactQuery/cacheKeys';
import { getGuestBagDetailed } from '@/modules/bag/api';
import { type Language } from '@/modules/language/constants';

export function guestCheckoutSummaryQueryOptions({
  products,
  language,
}: {
  products: CheckoutProduct[];
  language: Language;
}) {
  const bagItems = createGuestBagRequestBody(products);

  return queryOptions({
    queryKey: [RQ_CHECKOUT_SUMMARY_GUEST, language, bagItems],
    enabled: products.length > 0,
    retry: false,
    refetchOnMount: 'always',
    queryFn: async () => {
      const response = await getGuestBagDetailed({ lang: language, bagItems });

      return response.data;
    },
    select: (data) => mapGuestBagToOrderSummary(data, products[0]?.seller.id),
  });
}
